function BadgeHistory({name ,className}:{
    name: string
    className?: string
}) {
  return (
    <div className={`rounded-[62px]  text-base font-semibold text-[#FFFFFF] py-3 px-4 min-w-32  text-center ${className}`}>
      {name}
    </div>
  )
}

export default BadgeHistory
